import React from 'react';
import { roleLabel, roleTone } from './types';

export default function RoleChip({ role }: { role: string }) {
  return (
    <span className={`inline-flex items-center rounded-full px-2 py-0.5 text-[0.6875rem] font-medium ring-1 ring-inset ${roleTone(role)}`}>
      {roleLabel(role)}
    </span>
  );
}
